import { lcidTable } from "./lcidTable"

export const from = (lcidCode: number): string => {
    return lcidTable[lcidCode] ?? "en_US";
}